import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-settlement-detail',
  templateUrl: './settlement-detail.component.html',
  styleUrls: ['./settlement-detail.component.scss']
})
export class SettlementDetailComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
